module.exports = __webpack_public_path__ + "static/assets/6bcb77943c4f72322e154302a761f456.png";